export default "__VITE_ASSET__BvR47_qf__"